<template>
  <div class="main">
    <AllHeader title="政策法规"></AllHeader>
    <div class="wrapper">
      <NewsList fenlei="政策法规"></NewsList>
    </div>
  </div>
</template>
<script>
import AllHeader from "@/components/AllHeader.vue";
import NewsList from "@/components/NewsList.vue";
import Bus from "@/utils/bus.js";
export default {
  data() {
    return {
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
  },
  components: {
    AllHeader,
    NewsList
  }
};
</script>
<style lang="less" scoped>
.main {
  margin-top: 20px;
  width: 100%;
  .wrapper {
    width: 95%;
    margin: 30px auto;
  }
}
</style>